export default "__VITE_ASSET__7b2551b0__"